import React from "react";
import "../../styles/user.css"

const providerMenuItems = [
      { label: "Allergies" },
      { label: "Medications" },
      { label: "Lab Results" },
      { label: "Clinical Reminders" },
      { label: "Appointments" },
      { label: "Vital Signs" },
      { label: "Provider Notes" },
      { label: "Medical History" },
      { label: "BMI" },
      { label: "Reports" },
      // Add more items as needed, matching your screenshot
];

const ProviderMenu = () => (
      <div className="provider-menu-container">
            <ul className="provider-menu-list">
                  {providerMenuItems.map((item, idx) => (
                        <li key={idx} className="provider-menu-item">
                              {/* <span className="provider-menu-icon">{item.icon}</span> */}
                              <span className="provider-menu-label">{item.label}</span>
                        </li>
                  ))}
            </ul>
      </div>
);

export default ProviderMenu;